import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setPhotos = info => {
	return {
		type: ActionTypes.LOAD_PHOTOS,
		photos: info.data
	};
};

export const loadPhotos = () => {
	return dispatch => {
		axios
			.get("https://getupstudio.co/solanasapi/gallery/")
			.then(response => {
				dispatch(setPhotos(response.data));
			})
			.catch(error => {});
	};
};

export const insertEvent = (eventname, photos, token) => {
	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/gallery/",
				{
					eventname: eventname,
					photos: photos
				}
			)
			.then(response => {
				dispatch(loadPhotos());
			})
			.catch(error => {});
	};
};



export const deletePhoto = (idphoto, token) => {
	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/gallery/deletephoto",
				{
					idphoto: idphoto.id
				}
			)
			.then(response => {
				dispatch(loadPhotos());
			})
			.catch(error => {});
	};
};


export const deleteEvent = (idevent, token) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"https://getupstudio.co/solanasapi/gallery/deletegallery",
				{
					idevent: idevent
				}
			)
			.then(response => {
				dispatch(loadPhotos());
			})
			.catch(error => {});
	};
};

export const addPhotos = (idevent, photos, token) => {
	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/gallery/addphotos",
				{
					idevent: idevent,
					photos: photos
				}
			)
			.then(response => {
				dispatch(loadPhotos());
			})
			.catch(error => {});
	};
};
